import React, { useEffect, useState } from "react";
import { InputBase, Select, MenuItem, FormControl, InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Text from "components/common/Text";
import { makeStyles } from "@mui/styles";
import Paper from "components/common/Paper";
import IconButton from "components/common/IconButton";
import { GridSearchIcon } from "@mui/x-data-grid";
import CTable from "components/common/Table";
// import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import Stack from "components/common/Stack";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EventIcon from "@mui/icons-material/Event";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import { TripDetailApiData } from "stores/TripDtailsStore/TripDetailApi";

const columns = [
  { field: "customer_name", headerName: "Customer Name" },
  { field: "source", headerName: "Source" },
  { field: "destination", headerName: "Destination" },
  { field: "created_at", headerName: "Date & Time" },
  { field: "trip_status", headerName: "Trip Status" },
];

const useStyles = makeStyles((theme) => ({

  table_date: {
    fontSize: "10px",
    height: "37px",
    fontWeight: "600" ,
    "@media (max-width:768px)": { width: "218%" },
  },
  searchBox: {
    float: "right",
    display: "flex",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginBottom: "20px",
    marginTop:'1rem',
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    height:'25px',
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
  center:{
    marginTop: "1.6rem" 
  },
  navigation_heading_Container:{
    display:'flex',
    justifyContent:"space-between"
  },
  navigation_text:{
    fontSize: "22px", 
    marginBottom: "40px" ,
    color:"#707070"

  },
  fileDownload_icon:{
    fontSize: "20px", 
    marginTop: "3px" 
  },
  searchBox_paper:{
    padding: "2.5px 0",
    display: "flex",
    alignItems: "center",
    width: "200px",
    height: "32px"
  },
  datePickerInput:{
    fontSize: "13px", marginLeft: "-5px", 
    cursor:'pointer'
  }
}));

const TripDetail = ({
  data,
  onChange,
  searchhandleChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,

  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  limit,
  page,
  isLoading,
  totalCount,
  onPageChange,
  handleReset,
  tripStatus,
  handleTripStatusChange
}) => {
  const classes = useStyles();
  const [filteredData, setFilteredData] = useState(data);
  // const [tripStatus, setTripStatus] = useState('');

  // useEffect(() => {
  //   const fetchVehicleData = async () => {
  //       try {
  //           const limit = totalCount;
  //               // const data = await TripDetailApiData.exportTripDetailApiData({ limit });
                
  //               // setFilteredData(data?.result?.tripDetails); 
  //       } catch (error) {
  //           console.error("Error exporting Navigation data:", error);
  //       }
  //   };

  //       fetchVehicleData();
  //   }, [totalCount]);


  const downloadAsExcel = () => {
    const navigationData = filteredData.map((d) => ({
      CustomerName: d?.customer_name,
       Source: d?.source,
       Destination: d?.destination,
      DateAndTime : d?.created_at,
      TripStatus: d?.trip_status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(navigationData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Trip Data");
    XLSX.writeFile(workbook, "TripDetail.xlsx");
  };

  useEffect(() => {
   
      setFilteredData(data);
    
  }, [ data]);

  // const handleTripStatusChange = (event) => {
  //   setTripStatus(event.target.value);
  // };

  return (
    <>
      <Box className={classes.center}>
        <Card>
          <CardContent>
            <Box>
              <Stack
              className={classes.navigation_heading_Container}
                direction={{ sm: "column", xs: "column", md: "row" }}
                spacing={2}
              >
                <Text
                 className={classes.navigation_text}
                 variant="h5"
                >
                  Trip Detail
                </Text>
                <span
                  onClick={() => downloadAsExcel(data)}
                  className={classes.exportfile}
                >
                  <FileDownloadIcon 
                 className={classes.fileDownload_icon}
                  />
                  Export Report
                </span>
              </Stack>
              <Box className={classes.searchBox}>
                <Paper
                className={classes.searchBox_paper}
                >
                  <IconButton
                    type="submit"
                    sx={{ p: "5px" }}
                    aria-label="search"
                  >
                    <GridSearchIcon />
                  </IconButton>
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    onChange={(e) =>
                      searchhandleChange("inputsearch", e.target.value)
                    }
                    inputProps={{ "aria-label": "search" }}
                  />
                </Paper>
                {/* <FilterListOutlinedIcon
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                /> */}
              </Box>
              <Box sx={{  marginTop:'1rem',display:'flex' ,gap:'10px'}}>
                <FormControl fullWidth size="small" sx={{maxWidth:'200px'}}>
                  <InputLabel
                  className={classes.datePickerInput}
                    id="daterange-label"
                  >
                    Date Range
                  </InputLabel>
                  <OutlinedInput
                    label="Date Range"
                    className={classes.table_date}
                    id="outlined-adornment-amount"
                    value={
                      fromat_date_from && fromat_date_to
                        ? `${fromat_date_from} - ${fromat_date_to}`
                        : ""
                    }
                    onClick={handleDatePickerOpen}
                    endAdornment={
                      <InputAdornment position="end" sx={{cursor:'pointer'}}>
                        <EventIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl className={classes.filterSelect}  size="small" sx={{minWidth:'200px'}}>
                  <InputLabel>Trip Status</InputLabel>
                  <Select
                    value={tripStatus}
                    onChange={handleTripStatusChange}
                    label="Trip Status"
                    sx={{height:'38px',fontSize:'14px'}}
                  >
                    <MenuItem sx={{fontSize:'14px'}} value="SAVED">SAVED</MenuItem>
                    <MenuItem sx={{fontSize:'14px'}} value="ENQUIRED">ENQUIRED</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Dialog
                open={datePickerOpen !== undefined ? datePickerOpen : false}
                onClose={handleDatePickerClose}
                title="Select a date range"
                children={
                  <DatePickerModal
                    onClose={handleDatePickerClose}
                    onDatePickerSub={onDatePickerSub}
                    from_date={from_date}
                    to_date={to_date}
                    handleChange={onChange}
                    handleReset={handleReset}
                  />
                }
              />
            </Box>
            <CTable
              columns={columns}
              data={filteredData ?? []}
              pagination={true}
              page={page}
              rowsPerPage={limit}
              isLoading={isLoading}
              count={totalCount}
              onPageChange={onPageChange}
            />
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default TripDetail;
